import script from "./AppEmojiPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AppEmojiPicker.vue?vue&type=script&setup=true&lang=js"

import "./AppEmojiPicker.vue?vue&type=style&index=0&id=36ec30ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ec30ba"]])

export default __exports__